query ConfigsList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: ConfigsFilterInput
) {
  configs(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      key
      value
      createdAt
      updatedAt
      deletedAt
      deleted
    }
    count
  }
}
